// extracted by mini-css-extract-plugin
export default {"domainDisplayLayout":"DomainDisplay_domainDisplayLayout__+GpkH","intlMessage":"DomainDisplay_intlMessage__LPFZq","internationalizedLink":"DomainDisplay_internationalizedLink__UAlkn"};